var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptySurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 150,
    viewBox: "0 0 288 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230 75C230 116.421 196.421 150 155 150C113.579 150 79.9999 116.421 79.9999 75C79.9999 33.5786 113.579 0 155 0C196.421 0 230 33.5786 230 75Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.572 131.815H127.032C124.572 131.815 122.603 129.84 122.603 127.371V45.6473C122.603 43.1783 124.572 41.2031 127.032 41.2031H251.572C254.032 41.2031 256 43.1783 256 45.6473V127.42C256 129.84 254.032 131.815 251.572 131.815Z",
    fill: "#D0ECF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 122.679H122.603V41.708C122.603 39.1505 124.572 37.1045 127.032 37.1045H251.572C254.032 37.1045 256 39.1505 256 41.708V122.679Z",
    fill: "#117BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.32 38.3633H127.55C125.725 38.3633 124.246 39.8435 124.246 41.6695V121.368H254.625V41.6695C254.625 39.8435 253.145 38.3633 251.32 38.3633Z",
    fill: "#EBF7F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.334 131.814H174.319V148.11H204.334V131.814Z",
    fill: "#D0ECF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.84 147.884H163.763C163.179 147.884 162.706 148.358 162.706 148.942C162.706 149.526 163.179 150 163.763 150H214.84C215.424 150 215.897 149.526 215.897 148.942C215.897 148.358 215.424 147.884 214.84 147.884Z",
    fill: "#D0ECF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.223 129.562C190.59 129.562 191.699 128.453 191.699 127.084C191.699 125.716 190.59 124.606 189.223 124.606C187.856 124.606 186.747 125.716 186.747 127.084C186.747 128.453 187.856 129.562 189.223 129.562Z",
    fill: "#A0DDE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204.334 138.777L174.319 143.221V131.814H204.334V138.777Z",
    fill: "#A0DDE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.227 48.9563C135.227 47.4347 136.46 46.2012 137.981 46.2012H243.362C244.883 46.2012 246.116 47.4347 246.116 48.9563V112.273C246.116 113.794 244.883 115.028 243.362 115.028H137.981C136.46 115.028 135.227 113.794 135.227 112.273V48.9563Z",
    fill: "#D5E7E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.104 47.6331C134.104 46.1115 135.337 44.8779 136.858 44.8779H242.239C243.76 44.8779 244.993 46.1115 244.993 47.6331V110.949C244.993 112.471 243.76 113.704 242.239 113.704H136.858C135.337 113.704 134.104 112.471 134.104 110.949V47.6331Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.196 64.7121V71.4703H191.35V64.6201C192.771 64.1604 193.825 62.919 193.825 61.4019C193.825 59.5169 192.175 57.9998 190.112 57.9998C188.096 57.9998 186.4 59.5169 186.4 61.4019C186.446 63.011 187.637 64.3443 189.196 64.7121Z",
    fill: "#01AAE0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.503 72.5276C162.615 72.6655 160.278 74.9183 160.049 77.7687H166.557C166.603 77.7687 166.603 77.7687 166.649 77.7687H207.35V72.5276H165.503Z",
    fill: "#0ED6E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 72.5276H214.179V78.5043C214.179 78.5503 214.179 78.5503 214.179 78.5962V96.6643H220V78.3204C219.954 75.1941 217.525 72.6655 214.5 72.5276Z",
    fill: "#13E0F9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M207.301 72.5276V77.7687H213.305C213.717 77.7687 214.084 78.0905 214.13 78.5043V72.5276H207.301Z",
    fill: "#0CC4E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M212.616 98.1357H205.786V103.377H212.616V98.1357Z",
    fill: "#01AAE0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160 78.3205V84.619H165.821V78.5963C165.821 78.1826 166.142 77.8148 166.554 77.7688H160.046C160 77.9527 160 78.1366 160 78.3205Z",
    fill: "#0092C0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M165.821 97.3082V84.6191H160V97.584C160 100.802 162.567 103.377 165.775 103.377H165.821V97.4001C165.821 97.3541 165.821 97.3541 165.821 97.3082Z",
    fill: "#01AAE0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M205.789 98.1357H166.646C166.234 98.1357 165.867 97.8139 165.821 97.4001V103.377H205.789V98.1357Z",
    fill: "#117BC7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.996 87.4486C201.214 87.4486 200.397 86.3318 200.258 86.0157C199.876 85.1419 198.858 84.7437 197.985 85.1263C197.111 85.5089 196.714 86.5273 197.096 87.4011C197.677 88.7299 199.595 90.9028 202.996 90.9028C206.362 90.9028 208.407 88.7733 209.076 87.5233C209.526 86.6823 209.209 85.6357 208.368 85.1856C207.528 84.7356 206.482 85.0525 206.032 85.8935C205.821 86.2884 204.811 87.4486 202.996 87.4486Z",
    fill: "#3F3F3F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.858 87.4486C175.077 87.4486 174.259 86.3318 174.121 86.0157C173.738 85.1419 172.72 84.7437 171.847 85.1263C170.974 85.5089 170.576 86.5273 170.958 87.4011C171.54 88.7299 173.457 90.9028 176.858 90.9028C180.225 90.9028 182.27 88.7733 182.938 87.5233C183.388 86.6823 183.071 85.6357 182.231 85.1856C181.39 84.7356 180.344 85.0525 179.895 85.8935C179.683 86.2884 178.674 87.4486 176.858 87.4486Z",
    fill: "#3F3F3F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.104 47.6331C134.104 46.1114 135.337 44.8779 136.858 44.8779H242.239C243.76 44.8779 244.993 46.1115 244.993 47.6331V50.9335H134.104V47.6331Z",
    fill: "#04B7EF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M240.903 47.9062C240.903 48.5143 240.411 49.0074 239.803 49.0074C239.195 49.0074 238.703 48.5143 238.703 47.9062C238.703 47.298 239.195 46.8049 239.803 46.8049C240.411 46.8049 240.903 47.298 240.903 47.9062Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.778 47.9062C236.778 48.5143 236.285 49.0074 235.677 49.0074C235.07 49.0074 234.577 48.5143 234.577 47.9062C234.577 47.298 235.07 46.8049 235.677 46.8049C236.285 46.8049 236.778 47.298 236.778 47.9062Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M232.651 47.9062C232.651 48.5143 232.159 49.0074 231.551 49.0074C230.944 49.0074 230.451 48.5143 230.451 47.9062C230.451 47.298 230.944 46.8049 231.551 46.8049C232.159 46.8049 232.651 47.298 232.651 47.9062Z",
    fill: "#ED509B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySurveys);
export default __webpack_public_path__ + "static/media/EmptySurveys.b819df251427309cbc395da5a9b9f7e6.svg";
export { ForwardRef as ReactComponent };